"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateClientWithAmplifyInstance = void 0;
var generateClientWithAmplifyInstance_1 = require("./generateClientWithAmplifyInstance");
Object.defineProperty(exports, "generateClientWithAmplifyInstance", { enumerable: true, get: function () { return generateClientWithAmplifyInstance_1.generateClientWithAmplifyInstance; } });
